import { RootState } from 'app/store';
import { useTypedSelector } from 'common/hooks/store';
import { debugToggleByType } from 'features/internal/internal-settings.slice';
import { ToggleType } from 'features/internal/internal.models';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectIsSidebarOpen } from './sidebarSlice';

const Icon: FC = () => {
  const isNewSideBarEnabledDebugToggle = useSelector((state: RootState) =>
    debugToggleByType(state, ToggleType.DisplayNewSideBar)
  );

  const isSidebarOpenLegacy = useTypedSelector(
    (state: RootState) => state.sidebar.isSidebarOpen
  );

  const isSidebarOpen = useSelector(selectIsSidebarOpen);

  const [logoUrl, scale] =
    ((isNewSideBarEnabledDebugToggle?.enabled ?? false) && isSidebarOpen) ||
    ((!isNewSideBarEnabledDebugToggle?.enabled ?? false) && isSidebarOpenLegacy)
      ? ['ruler_white.svg', 'scale-50']
      : ['r_white.svg', 'scale-75'];

  return (
    <>
      <a href="/dashboard">
        <img
          className={`hidden md:block ${scale}`}
          alt="Ruler Analytics"
          src={process.env.PUBLIC_URL + '/media/logos/' + logoUrl}
          width="250px"
        />
      </a>

      <a href="/dashboard">
        <img
          className={`block md:hidden scale-50`}
          alt="Ruler Analytics"
          src={process.env.PUBLIC_URL + '/media/logos/ruler_white.svg'}
          width="250px"
        />
      </a>
    </>
  );
};

export default Icon;
